import moment from "moment-timezone";
import { UpdateObject } from "simple-ui-components/lib/Utility/Utility";

export const Log = (message, error) => {
  if (process.env.REACT_APP_NODE_ENV === "development") {
    if (error) {
      console.error(message + " " + error);
    } else {
      console.log(message);
    }
  }
};

export const changeDateFormate = (date) => {
  return moment(date).format("YYYY/MM/DD HH:mm:ss");
};

export const getIndex = (value, list) => {
  let toReturn = -1;
  list.forEach((item, index) => {
    if (item.id === value) {
      toReturn = index;
    }
  });
  return toReturn;
};

export const getIndexNumber = (list) => {
  let toReturn = 0;
  if (list.length > 0) {
    toReturn = list[0].index;
    for (let i = 0; i < list.length; ++i) {
      toReturn = list[i].index > toReturn ? list[i].index : toReturn;
    }
  }
  return toReturn + 1;
};

export const selectNextOnEnter = (event, next) => {
  if (event.keyCode === 13 || event.keyCode === 9) {
    event.preventDefault();
    next.current.focus();
  }
};

export const CheckValidity = (value, data, key) => {
  if (!data) {
    return true;
  }
  data[key].value = value;
  data[key].touched = true;

  let currentElement = data[key];
  let isValid = true;

  if (
    currentElement.validation.required &&
    currentElement.type !== "autocomplete"
  ) {
    isValid = value !== "" && isValid;
    if (currentElement.type === "checkbox") {
      isValid = value && isValid;
    } else if (currentElement.input.type !== "number") {
      isValid = value.trim() !== "" && isValid;
    }
  }

  if (currentElement.validation.min) {
    isValid = value.length >= currentElement.validation.min && isValid;
  }

  if (currentElement.validation.max) {
    isValid = value.length <= currentElement.validation.max && isValid;
  }

  if (currentElement.validation.minVal) {
    if (currentElement.input.type === "number") {
      value = value.replaceAll(",", ".");
    }
    isValid = value >= currentElement.validation.minVal && isValid;
  }

  if (currentElement.validation.maxVal) {
    if (currentElement.input.type === "number") {
      value = value.replaceAll(",", ".");
    }
    isValid = value <= currentElement.validation.maxVal && isValid;
  }

  if (currentElement.input.type === "email") {
    const pattern =
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    isValid = pattern.test(value) && isValid;
  }

  if (currentElement.validation.notEqual) {
    let toCompare = data[currentElement.validation.notEqual];
    if (toCompare.touched) {
      let otherVal = data[currentElement.validation.notEqual].value;
      isValid = value !== otherVal && isValid;
    }
  }

  if (currentElement.validation.equal) {
    let toCompare = data[currentElement.validation.equal];
    if (toCompare.touched) {
      let otherVal = data[currentElement.validation.equal].value;
      isValid = value === otherVal && isValid;
    }
  }

  if (currentElement.validation.isLicense) {
    const pattern =
      /^(([A-Z]{2}-\d{2}-(\d{2}|[A-Z]{2}))|(\d{2}-(\d{2}-[A-Z]{2}|[A-Z]{2}-\d{2})))$/;
    isValid = pattern.test(value) && isValid;
  }

  return isValid;
};

export const UpdateInputChange = (data, value, key) => {
  let updatedObjects = UpdateObject(data, {
    [key]: UpdateObject(data[key], {
      value: value,
      valid: CheckValidity(value, data, key),
      touched: true,
    }),
  });

  let isValidForm = true;
  for (let inputIdentifier in updatedObjects) {
    if (updatedObjects[inputIdentifier].touched) {
      let newValue = updatedObjects[inputIdentifier].value;
      if (key === inputIdentifier) newValue = value;
      updatedObjects[inputIdentifier].valid = CheckValidity(
        newValue,
        updatedObjects,
        inputIdentifier
      );
    }
    if (inputIdentifier !== "submit") {
      isValidForm = updatedObjects[inputIdentifier].valid && isValidForm;
    }
  }

  updatedObjects = CheckFormValidity(updatedObjects);

  return updatedObjects;
};

export const CheckFormValidity = (data) => {
  let updatedObjects = { ...data };
  let isValidForm = true;
  for (let inputIdentifier in data) {
    if (inputIdentifier !== "submit") {
      let toCheck =
        inputIdentifier === "type" &&
        updatedObjects[inputIdentifier].value !== "30"
          ? updatedObjects[inputIdentifier].value === ""
            ? false
            : true
          : updatedObjects[inputIdentifier].valid;
      isValidForm = toCheck && isValidForm;
    }
  }

  updatedObjects = UpdateObject(updatedObjects, {
    submit: UpdateObject(data.submit, {
      valid: isValidForm,
    }),
  });
  return updatedObjects;
};

export const ReplaceWord = (
  string,
  find,
  replace,
  find1,
  replace1,
  find2,
  replace2
) => {
  let toReturn = string.split(find).join(replace);
  if (find1 && replace1) {
    toReturn = toReturn.split(find1).join(replace1);
  }
  if (find2 && replace2) {
    toReturn = toReturn.split(find2).join(replace2);
  }
  return toReturn;
};

export const DateTimeFormatTimezone = (date) =>
  moment.tz(date.slice(0, -1), "Europe/Lisbon").format("YYYY-MM-DD HH:mm:ss");
export const DateFormatTimezone = (date) => {
  return moment.tz(date.slice(0, -1), "Europe/Lisbon").format("YYYY-MM-DD");
};

export const TimeFormatTimezone = (date) => {
  return moment.tz(date.slice(0, -1), "Europe/Lisbon").format("HH:mm:ss");
};
